import { graphql } from 'gatsby';
import * as React from 'react';
import { ArticleSection } from '../components/ArticleSection';
import { BrandBox } from '../components/BrandBox';
import { Container } from '../components/Container';
import {
  ArticleHeader,
  ArticleIngress,
  ArticleTop,
  ServiceWrapper
} from '../components/Sections';
import { IDefaultPropsWithData } from '../IDefaultProps';
import { Base } from '../layouts/Base';
import {
  ContentfulArticleSection,
  ContentfulPage
} from '../types/graphql-types';
import { SEO } from '../utils/seo';

const Page = (page: ContentfulPage) => (
  <ServiceWrapper>
    <ArticleTop>
      <BrandBox />
      {(page.name || page.header || page.preamble) && (
        <ArticleHeader>
          <h1>{page.header || page.name}</h1>

          {page.preamble && (
            <ArticleIngress
              dangerouslySetInnerHTML={{
                __html: page!.preamble!.childContentfulRichText!.html as string
              }}
            />
          )}
        </ArticleHeader>
      )}
    </ArticleTop>

    {page.sections &&
      page.sections!.map(
        (section: ContentfulArticleSection | null, index: number) => (
          <ArticleSection key={index} section={section} />
        )
      )}
  </ServiceWrapper>
);

export default ({ data }: IDefaultPropsWithData) => {
  const page = data.contentfulPage!;
  return (
    <Base>
      <SEO
        title={page.name as string}
        description={
          (page.preamble &&
            (page.preamble!.childContentfulRichText!.html as string)) ||
          undefined
        }
      />
      <Container>
        <Page {...page} />
      </Container>
    </Base>
  );
};

export const query = graphql`
  query($id: String!) {
    contentfulPage(id: { eq: $id }) {
      name
      header
      preamble {
        childContentfulRichText {
          html
        }
      }
      sections {
        text {
          childContentfulRichText {
            html
          }
        }
        image {
          fluid(maxWidth: 660, quality: 100) {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  }
`;
